// This is where un-routed containers go
export default {
  template: `
    <app-container>
      <uimessages-container></uimessages-container>
      <new-user-container></new-user-container>
      <settings-container></settings-container>
      <header-container></header-container>
      <router-container></router-container>
    </app-container>
  `,
};
